import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';


import HtmlElementFormatter from './../../utils/formatters/HtmlElementFormatter';
import SessionManager from "../../businessLayer/managers/SessionManager";
import HttpStatusCode from "../../utils/httpProtocol/HttpStatusCode";

export default function AppConfigurationSection(){

    const location = useLocation()
    const navigate = useNavigate()

    function toggleAppConfigurationModal(){
        const targetelement = "app-configuration-modal1";
        const classToHide = "hide";
        const classToDisplay = "display";
        HtmlElementFormatter.toggleUlElement(targetelement, classToHide, classToDisplay);       
    }

     function processLogOut(){
        SessionManager.exitApplication(logoutCallback);
    }

    
    //#region Private Functions BEGIN

    function logoutCallback(httpResponse) {
        //console.log("logoutCallback-httpResponse", httpResponse);       
        return navigate("/public/logout", { 
            state: { from: location.pathname },
            replace: true 
        });               
    }
    //#region Private Functions END


    return(
        <>
            <button className="app-configuration-button" type="button" onClick={toggleAppConfigurationModal}>Account</button>
            <div id="app-configuration-modal1" className="app-configuration-section hide">
                <ul className="app-configuration-list"> 
                    <li className="app-configuration-item">
                        <Link to="/private/appconfiguration/myprofile" className="link-element"> My Profile</Link>
                    </li>
                    <li className="app-configuration-item">
                        <button type="button" onClick={processLogOut} className="link-element">Log Out</button>
                    </li>
                </ul>
            </div>
        </>
    );
}